import { Component, OnInit } from '@angular/core';
import { AuthService } from './../../../services/auth.service';
import { MemberService } from '../../../rest/api/member.service';
import { HelperService } from './../../../services/helper.service';
import { environment } from './../../../../environments/environment';
import _ from 'lodash';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-public-space',
  templateUrl: './public-space.component.html',
  styleUrls: ['./public-space.component.scss']
})
export class PublicSpaceComponent implements OnInit {
  accessToken: any;

  spaceCategoryData: any;
  spaceListData: any;
  spaceLoader = true;
  bspaceUrl: any;
  iframeCode: any;
  spaceUid: any;
  spaceId: any;

  totalCount: number;
  itemsPerPage = 5;
  currentPage = 1;

  categoryId = '';
  keywords = '';
  langShortCode: any;
  selectedSpace: any;

  constructor(
    private authService: AuthService,
    public memberService: MemberService,
    public helperService: HelperService,
    private route: ActivatedRoute,
  ) {
    this.accessToken = `Bearer ${this.authService.getAccessToken()}`;
    this.langShortCode = localStorage.getItem('language') ? localStorage.getItem('language') : undefined;
    this.bspaceUrl = environment.baseUrl;
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.spaceId = params.id;
    });
    this.getSpaceList(1, this.itemsPerPage, '', '');
  }

  getSpaceList(page, limit, categoryId, keywords) {
    const thisobject = this;
    const status = 'published';
    this.memberService.getMemberSpace({
      Authorization: this.accessToken,
      page: page,
      paginate: limit,
      categoryId: categoryId || undefined,
      keywords: keywords || undefined,
      status: status
    }).subscribe((response: any) => {
      thisobject.spaceLoader = false;
      thisobject.totalCount = response && response.meta && response.meta.pagination && response.meta.pagination.total ? response.meta.pagination.total : 0;
      thisobject.spaceListData = response && response.data ? response.data : [];
    }, err => {
      thisobject.spaceListData = [];
      thisobject.spaceLoader = false;
    });
  }

  pageChanged(event) {
    this.spaceLoader = true;
    this.currentPage = event;
    this.getSpaceList(event, this.itemsPerPage, this.categoryId, this.keywords);
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  selectSpace(data) {
    if (data) {
      this.selectedSpace = data;
    }
  }

  spaceEmitData(response) {
    const spaceUuid = response.uuid;
    _.remove(this.spaceListData, (space) => {
      return space.uuid === spaceUuid;
    });
  }
}
